export const getElementSizes = (element: HTMLElement): number[] => {
  const computedStyle = getComputedStyle(element);

  const sizesDefinition = computedStyle.getPropertyValue('--responsive-container')
    || (computedStyle['-ie-responsive-container'] as string);

  return sizesDefinition
    ?.replace(/\$/g, '')
    ?.split(',')
    ?.map((size) => parseInt(size.trim(), 10));
};

export const responsive = (element: HTMLElement, prop = 'component-width'): ResizeObserver => {
  const sizes = getElementSizes(element);

  const observer = new ResizeObserver((entries) => {
    entries.forEach(({ contentRect: { width } }) => {
      element.setAttribute(
        prop,
        (sizes?.find((size) => size < width) || 0).toString(),
      );

      (element as any).onAfterResize?.();
    });
  });
  observer.observe(element);
  return observer;
};
